import { FormEvent, useState } from 'react';

//Button imports
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormHelperText,
    IconButton,
    TextField
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

//Global theme import
import { cancelButtonStyle, editIconStyle, saveButtonStyle } from '../style';
import { Sections } from './AddItemWideButton';
import { StyledDialogActions } from '../styledComponents';

export type FormData = {
    id?: string | undefined;
    name: string | undefined;
    value: string | (() => string);
    type: string | undefined;
    isInner: boolean | undefined;
    section: string | undefined;
};

interface ModalProps {
    formData: FormData;
    onValueUpdate: (value: string) => void;
}

const Modal = ({ formData, onValueUpdate }: ModalProps) => {
    const { name, value: data, type, section } = formData;

    const [isDialogOpened, setDialogOpened] = useState(false);

    const [value, setValue] = useState<string>(data);
    const [showErrorHelperText, setErrorHelperText] = useState(false);

    const valueType = type === 'Number' ? 'number' : 'text';

    const handleCloseDialog = () => {
        setValue(data);
        setDialogOpened(false);
        setErrorHelperText(false);
    };

    const handleSave = async (e: FormEvent) => {
        e.preventDefault();
        if (section === Sections.WhatDidYouDo) {
            if (/^[A-Za-z\s`!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>/?~]*$/.test(value)) {
                onValueUpdate(value);
                setDialogOpened(false);
            } else {
                setErrorHelperText(true);
            }
        } else {
            onValueUpdate(value);
            setDialogOpened(false);
        }
    };

    const getLabelByConfig = (name: string | undefined) => {
        switch (name) {
            case 'Pagination':
                return 'Items per page';
            case 'Logout timeout':
                return 'Minutes';
            default:
                return 'Value';
        }
    };

    return (
        <div>
            <IconButton aria-label="edit" onClick={() => setDialogOpened(true)}>
                <EditOutlinedIcon sx={editIconStyle} />
            </IconButton>
            <Dialog open={isDialogOpened} onClose={handleCloseDialog}>
                <DialogTitle variant="h3">{name}</DialogTitle>
                <form onSubmit={handleSave}>
                    <DialogContent>
                        <TextField
                            required
                            margin="dense"
                            id="name"
                            label={getLabelByConfig(name)}
                            type={valueType}
                            fullWidth
                            variant="outlined"
                            value={value}
                            onChange={(v) => {
                                if (valueType === 'number') {
                                    const regex = /^[0-9\b]+$/;
                                    if (v.target.value === '' || regex.test(v.target.value)) {
                                        setValue(v.target.value);
                                    }
                                } else if (valueType === 'text') {
                                    setValue(v.target.value);
                                }
                            }}
                        />
                        {showErrorHelperText ? (
                            <FormHelperText error={showErrorHelperText}>
                                {section === Sections.WhatDidYouDo
                                    ? 'Only letters are allowed.'
                                    : ''}
                            </FormHelperText>
                        ) : null}
                    </DialogContent>
                    <StyledDialogActions>
                        <Button sx={cancelButtonStyle} onClick={handleCloseDialog}>
                            Cancel
                        </Button>
                        <Button sx={saveButtonStyle} type="submit">
                            Save
                        </Button>
                    </StyledDialogActions>
                </form>
            </Dialog>
        </div>
    );
};

export default Modal;
